module.exports = __webpack_public_path__ + "static/award-fdm-video-converter-1bab0b7b710b947bc69aad2d11202dcd.png";